import { Link } from "react-router-dom";
import { comics, hotRanking } from "@/mocks/comics";

export default function RankingSection() {
  const ranked = hotRanking
    .map((id) => comics.find((c) => c.id === id))
    .filter((c): c is NonNullable<typeof c> => Boolean(c))
    .slice(0, 10);

  const [first, ...rest] = ranked;

  return (
    <section id="ranking" className="mx-auto max-w-[1400px] px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="text-sm font-medium text-primary-600">POPULAR RANKING</p>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">人气榜单精选</h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            综合阅读热度与读者口碑实时排行的韩漫人气榜单，本周最值得追的 10 部都在这里。
          </p>
        </div>
        <Link
          to="/categories"
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <Link
          to={`/comic/${first.id}`}
          className="card-lift group relative col-span-1 flex min-h-[280px] flex-col justify-end overflow-hidden rounded-lg lg:col-span-7"
        >
          <img
            src={first.cover}
            alt={`${first.title} 韩漫人气榜第一`}
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent"></div>
          <div className="relative z-10 p-6 md:p-8 text-background-50">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 font-heading text-lg">1</span>
              <span className="rounded bg-primary-500/90 px-2 py-0.5 text-xs">{first.status}</span>
            </div>
            <h3 className="mt-3 font-heading text-2xl md:text-3xl">{first.title}</h3>
            <p className="mt-2 line-clamp-2 max-w-2xl text-sm text-background-100">{first.intro}</p>
            <div className="mt-4 flex flex-wrap items-center gap-4 text-sm">
              <span className="flex items-center gap-1"><i className="ri-star-fill text-accent-400"></i>{first.score} 分</span>
              <span>{first.views} 人气</span>
              <span>{first.chapters} 话</span>
            </div>
          </div>
        </Link>

        <div className="col-span-1 flex flex-col gap-3 lg:col-span-5">
          {rest.map((c, i) => (
            <Link
              key={c.id}
              to={`/comic/${c.id}`}
              className="card-lift group flex items-center gap-4 rounded-lg bg-background-100 p-3"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 font-heading text-base text-secondary-700">
                {i + 2}
              </span>
              <img
                src={c.cover}
                alt={`${c.title} 封面`}
                loading="lazy"
                className="h-16 w-12 shrink-0 rounded object-cover object-top"
              />
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">{c.title}</h3>
                <p className="truncate text-xs text-foreground-600">{c.category}</p>
              </div>
              <div className="shrink-0 text-right">
                <div className="flex items-center justify-end gap-1 text-sm font-medium text-accent-600">
                  <i className="ri-star-fill text-xs"></i>{c.score}
                </div>
                <div className="mt-0.5 text-xs text-foreground-500">{c.status}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}